import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { DBCheckBoxObjective } from '_components';
import { getPanels } from '_helpers';
import { PatientCareCenterNoteSpecTestSection } from './Section';
import styles from './Common.module.css';
import { getAge } from '_helpers';

class SpecTestsRotatorCuffTearCluster extends React.Component {

    componentDidMount() {
        if (this.props.ageGt65 === null && this.props.age > 65) {
            this.props.updateBitField(this.props.noteId, 'PTOBJECTIVESPECTESTS', 'TSNO', this.props.tsno, 'TSRCTCAGEGT65', true);

        }
    }

    render() {
        if (this.props.panels.length > 0) {
            return (
                <PatientCareCenterNoteSpecTestSection id='obj_spec_tests_RotatorCuffTearCluster' name='Rotator Cuff Tear Cluster' visible={false} flagged={this.props.flagged} mopno={this.props.panels[0].MOPNO}>
                    <div className={styles.checkbox_row}>
                        <span className={styles.flag} />
                        <span className={styles.spacer} />
                        <label className={styles.label}>Age &gt; 65 years old</label>
                        <span className={styles.r} />
                        <DBCheckBoxObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVESPECTESTS'
                            entityKeyColumn='TSNO'
                            entityKeyValue={this.props.tsno}
                            field='TSRCTCAGEGT65'
                            disabled={true}
                            className={styles.checkbox_center}
                        />
                    </div>
                    <div className={styles.checkbox_row}>
                        <span className={styles.flag} />
                        <span className={styles.spacer} />
                        <label className={styles.label}>Weakness in ER</label>
                        <span className={styles.r} />
                        <DBCheckBoxObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVESPECTESTS'
                            entityKeyColumn='TSNO'
                            entityKeyValue={this.props.tsno}
                            field='TSRCTCWEAKER'
                            className={styles.checkbox_center}
                        />
                    </div>
                    <div className={styles.checkbox_row}>
                        <span className={styles.flag} />
                        <span className={styles.spacer} />
                        <label className={styles.label}>Night Pain</label>
                        <span className={styles.r} />
                        <DBCheckBoxObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVESPECTESTS'
                            entityKeyColumn='TSNO'
                            entityKeyValue={this.props.tsno}
                            field='TSRCTCNIGHTPAIN'
                            className={styles.checkbox_center}
                        />
                    </div>
                </PatientCareCenterNoteSpecTestSection>
            );
        } else {
            return (
                <span />
            )
        }

    }

}

function mapDispatchToProps(dispatch) {
    return {
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch)
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let tsno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESPECTESTS)
        .find(key => (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSNTNO === pk && noteType !== 1)));

    let flagCount = 0;
    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSRCTCAGEGT65) {
        flagCount++;
    }
    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSRCTCWEAKER) {
        flagCount++;
    }
    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSRCTCNIGHTPAIN) {
        flagCount++;
    }

    return {
        noteId: noteId,
        tsno: tsno,
        flagged: flagCount === 3 ? true : false,
        ageGt65: state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSRCTCAGEGT65,
        panels: getPanels(noteId, 'SpecialTest', 'RotatorCuffTearCluster'),
        age: getAge(state.entities.patients[state.ui.patients.selectedPtno].dob)
    };
}

const connectedSpecTestsRotatorCuffTearCluster = connect(mapStateToProps, mapDispatchToProps)(SpecTestsRotatorCuffTearCluster);
export { connectedSpecTestsRotatorCuffTearCluster as SpecTestsRotatorCuffTearCluster };


